import { userConstants } from "../constants/login.constants";

export function companyList(state = {}, action) {
    switch (action.type) {
        case userConstants.COMPANYALL_REQUEST:
            return {
                loading: true
            };
        case userConstants.COMPANYALL_SUCCESS:
            return {
                items: action.company
            };
        case userConstants.COMPANYALL_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}